export default {"src":"/_next/static/media/JSN.fa57a799.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};